import axios from "axios";

export const getDataSuburbAutocomplete = async (term) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get('/search/locationautocomplete', {
                params: {
                    term: term
                }
            })
            .then(
                (response) => {
                    resolve(response?.data);
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
};
